import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormArray, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { CustomerAddressModel } from '../../../../../shared/entities/customer-address.model';

@Component({
    selector: 'app-customers-addresses',
    templateUrl: './customers-addresses.component.html',
    styleUrls: ['./customers-addresses.component.scss']
})
export class CustomersAddressesComponent implements OnInit {

    @Input() formGroup: UntypedFormGroup;
    @Input() addresses: Array<CustomerAddressModel>;

    constructor(private formBuilder: UntypedFormBuilder) {
    }

    get addressesFormArray() {
        return this.formGroup.controls.addresses as UntypedFormArray;
    }

    ngOnInit(): void {
        this.addresses.forEach(address => {
            this.addFormItem(address);
        });
    }

    addFormItem(address?: CustomerAddressModel): void {
        const addressForm = this.formBuilder.group({
            uid: [(address) ? address.uid : null],
            address: [(address) ? address.address : null, [Validators.required, Validators.maxLength(1000)]],
            county_id: [(address) ? address.county_id : null, Validators.required],
            city_id: [(address) ? address.city_id : null, Validators.required],
            fnc_id: [(address) ? address.fnc_id : null, Validators.required],
            needDelete: [false],
        });
        this.addressesFormArray.push(addressForm);
    }

    removeFormItem(formIndex: number): void {
        const form = this.addressesFormArray.at(formIndex) as UntypedFormControl;
        form.patchValue({ needDelete: true });
    }

}
